import { render } from "./TableColumn.vue?vue&type=template&id=219e22a2"
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__